module.exports = __webpack_public_path__ + "menu.png?c0cfc66da5e907c5109803a3bbec145e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 308
// module chunks = 0